// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1aNfA","controls":"styles_controls__n6kC5","charLimit":"styles_charLimit__X8K5O","input":"styles_input__5d79Z","send":"styles_send__2nKoo"};